module.exports = __webpack_public_path__ + "img/9_23.12b0139e.png";